<template>
  <v-data-table
    :headers="tabela.headers"
    :items="perfis"
    :search="tabela.opcoes.pesquisa"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
  >
    <!-- Ordenação e Pesquisa -->
    <template v-slot:top>
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Numeração -->
    <template v-slot:[`item.numero`]="{ index }">
      <span>{{ index + 1 }}</span>
    </template>

    <!-- Deficiências --->
    <template
      v-for="deficiencia in relatorio.deficiencias"
      v-slot:[`item.${normalizarTexto(deficiencia.nome)}`]="{ item }"
    >
      <v-icon
        v-if="item.isDeficiente === null"
        :key="deficiencia.nome"
        color="grey"
      >
        quiz
      </v-icon>
      <v-icon
        v-else
        :key="deficiencia.nome"
        :color="(item[`${normalizarTexto(deficiencia.nome)}`] > 0) ? 'secondary': 'grey'"
      >
        {{ getCheckBoxIcon(item[`${normalizarTexto(deficiencia.nome)}`] > 0) }}
      </v-icon>
    </template>

    <!-- Legenda -->
    <template v-slot:[`body.append`]="{headers}">
      <tr>
        <td
          :colspan="headers.length"
        >
          <v-row class="justify-center mb-2" dense>
            <span class="caption grey--text text--darken-2 mr-8">LEGENDA</span>
            <v-icon color="grey" class="mr-1">quiz</v-icon> Não Respondeu
            <v-icon color="grey" class="ml-8 mr-1">check_box_outline_blank</v-icon> Não
            <v-icon color="secondary" class="ml-8 mr-1">check_box</v-icon> Sim
          </v-row>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { normalizar } from '@/modules/texto';

export default {
  name: 'TabelaResultadoUnidadeCadastro',

  components: {
    AppSort,
    AppSearch,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          {
            text: 'N°',
            value: 'numero',
            width: '10%',
            sortable: false,
          },
          {
            text: 'SERVIDOR',
            value: 'servidor',
            sortable: false,
          },
          ...this.relatorio.deficiencias.map((d) => ({
            text: d.nome.toUpperCase(),
            value: normalizar(d.nome),
            sortable: false,
            align: 'center',
          })),
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'servidor',
          selecionado: { id: 'servidor', descricao: 'Servidor' },
          lista: [
            { id: 'servidor', descricao: 'Servidor' },
            ...this.relatorio.deficiencias.map((d) => ({
              id: normalizar(d.nome),
              descricao: d.nome,
            })),
          ],
        },
      },
    };
  },

  computed: {
    perfis() {
      return this.relatorio.perfis.map((p) => {
        const deficiencias = {};
        p.deficiencias.forEach((d) => deficiencias[normalizar(d.nome)] = d.quantidade);
        return {
          id: p.id,
          servidor: p.servidor,
          isDeficiente: p.isDeficiente,
          ...deficiencias,
        };
      });
    },
  },

  methods: {
    normalizarTexto(texto) {
      return normalizar(texto);
    },
    getCheckBoxIcon(isChecked) {
      return isChecked ? 'check_box' : 'check_box_outline_blank';
    },
  },
};
</script>
